import { Permission } from "presentation/constant/ANAInfo/PermissionName";
import { TariffNatureMaintenanceProvider } from "presentation/store/TariffNature/TariffNatureMaintenanceProvider";
import { ANAInfoWrapper } from "presentation/view/components/ANAInfo/ANAInfoWrapper";
import { MessageBarWrapper } from "presentation/view/components/MessageBarWrapper";
import { TariffNatureMasterView } from "presentation/view/section/TariffNature/TariffNatureMasterView";
import { GridStyles } from "veronica-ui-component/dist/component/core/styled/table.styled";

const TariffNatureMaintenanceCont = () => {
    return <ANAInfoWrapper permission={Permission.TARIFF_NATURE_MAINTENANCE}>
        <MessageBarWrapper>
            <TariffNatureMaintenanceProvider>
                <GridStyles/>
                <TariffNatureMasterView/>
            </TariffNatureMaintenanceProvider>
        </MessageBarWrapper>
    </ANAInfoWrapper>
}

export default TariffNatureMaintenanceCont;